<div class="mb-3">
  <app-field-title [titleInfo]="inputContent" [formControlObj]="formControlObj">
    <input type="text" class="form-control" [formControl]="formControlObj" [name]="inputContent.inputContentTitle"
      [placeholder]="isOptionLoading ? 'Loading..' :'Your answer'" />
  </app-field-title>
</div>